export default __webpack_public_path__ + "src/assets/add.78c1ac0ea6edab179585a3b7cfb89e4a.svg";